import { useSelector } from 'react-redux';
import styled from 'styled-components';
import MessagingCopy from '../messaging/MessagingCopy';
import { DataOptions } from '../signup-data/signupDataOptions';
import { getCurrentStep, getNextSteps } from '../store/flow/selectors';
import { ButtonsGrid } from '../views-components/ButtonsGrid';
import { StepTitle } from '../views-components/StepTitle';
import { usePrivacyBanner } from '../views-components/usePrivacyBanner';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { getIsAccountCreationStep } from '../flow-management/getIsAccountCreationStep';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { jsx as _jsx } from "react/jsx-runtime";
// NOTE: This component was wrapped in a extra function component to avoid problematic cycles when frontend-infra-core migrates to Webpack 5
const HelperText = componentProps => {
  const HelperTextComponent = styled(MessagingCopy).withConfig({
    displayName: "BaseButtonsView__HelperTextComponent",
    componentId: "spwrc2-0"
  })(["", ""], props => props.className === 'Hide' && `visibility: hidden;`);
  return /*#__PURE__*/_jsx(HelperTextComponent, Object.assign({}, componentProps));
};
export const BaseButtonsView = ({
  onHighlightChange = () => {},
  onSelect = () => {},
  getButtonText,
  getButtonDescriptionText,
  setDataFn,
  type = 'default',
  footer,
  hasNextButton = false,
  nextButtonLabel,
  hasTitleTooltip = false,
  tooltipLink,
  shouldShowHelperText = true,
  helperTextString,
  helperTitleKey,
  columnCount,
  optionHeight,
  options,
  isSelected,
  title,
  expandableSubTitleSection = null,
  shouldDisableAutofocus = true,
  // Remove after ACQ1037
  shouldShowStepTitle = true,
  preTitle,
  shouldCenterLastRow = true,
  goToNextStep = true,
  shouldShowRecommendedLabel = () => false
}) => {
  const stepKey = useSelector(getCurrentStep);
  const {
    shouldShowToSNonOptionalStep
  } = usePrivacyBanner();
  const defaultHelperText = `views.${stepKey}.helperText`;
  const isAccountCreationStep = useSelector(state => getIsAccountCreationStep(state, getNextSteps(state)));
  const showCreateAccountButton = getFlowConfig().shouldSkipHubletSelectionNewUser && isAccountCreationStep;
  if (!stepKey) {
    return null;
  }
  const stepConfig = getStepConfig(stepKey);
  if (!stepConfig) {
    return null;
  }

  // Supporting only 1 question for now
  const dataKey = stepConfig.data[0];
  const preTitleMessage = preTitle || `views.${stepKey}.pre-title`;
  const helperTextMessage = helperTextString || defaultHelperText;
  const helperText = shouldShowHelperText && /*#__PURE__*/_jsx(HelperText, {
    className: !shouldShowHelperText ? 'Hide' : '',
    message: helperTextMessage
  });

  // Remove after ACQ1037
  if (!shouldShowStepTitle) {
    return /*#__PURE__*/_jsx(ButtonsGrid, {
      columnCount: columnCount,
      dataKey: dataKey,
      getButtonDescriptionText: getButtonDescriptionText,
      getButtonText: getButtonText,
      hasNextButton: hasNextButton || shouldShowToSNonOptionalStep,
      isSelected: isSelected,
      nextButtonLabel: nextButtonLabel,
      optionHeight: optionHeight,
      options: options || DataOptions[dataKey],
      setDataFn: setDataFn,
      shouldCenter: shouldCenterLastRow,
      shouldDisableAutofocus: shouldDisableAutofocus,
      stepKey: stepKey,
      type: type || shouldShowToSNonOptionalStep && 'radio',
      onHighlightChange: onHighlightChange,
      onSelect: onSelect
    }, dataKey);
  }
  return /*#__PURE__*/_jsx(BaseView, {
    expandableSubTitleSection: expandableSubTitleSection,
    footer: footer,
    helperText: helperText,
    preTitleMessage: preTitleMessage,
    title: title || /*#__PURE__*/_jsx(StepTitle, {
      hasTooltip: hasTitleTooltip,
      message: helperTitleKey,
      stepKey: stepKey,
      tooltipLink: tooltipLink
    }),
    children: /*#__PURE__*/_jsx(ButtonsGrid, {
      columnCount: columnCount,
      dataKey: dataKey,
      getButtonDescriptionText: getButtonDescriptionText,
      getButtonText: getButtonText,
      goToNextStep: goToNextStep,
      hasNextButton: hasNextButton || shouldShowToSNonOptionalStep || showCreateAccountButton,
      isSelected: isSelected,
      nextButtonLabel: nextButtonLabel,
      optionHeight: optionHeight,
      options: options || DataOptions[dataKey],
      setDataFn: setDataFn,
      shouldCenter: shouldCenterLastRow,
      shouldDisableAutofocus: shouldDisableAutofocus,
      shouldShowRecommendedLabel: shouldShowRecommendedLabel,
      stepKey: stepKey,
      type: type || shouldShowToSNonOptionalStep && 'radio',
      onHighlightChange: onHighlightChange,
      onSelect: onSelect
    }, dataKey)
  });
};